<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

function handleError() {
  clearError()
  navigateTo('/')
}

const contactDescription = `Grampian Business Finder never sleeps - online services are available 24/7, and our helpdesk is not restricted to "normal" office hours - who needs normal, we reply as soon as we can! Give us a shout or send us a message!`
</script>

<template>
  <div class="bg-slate-100 min-h-screen text-slate-700">
    <NavigationMain />
    <div class="mx-auto max-w-screen-2xl w-full px-6">
      <div class="flex flex-col max-w-6xl mx-auto pt-40">
        <HeadingText tag="h1" class="text-pink">
          Somethings gone Pete Tong!
        </HeadingText>
        <hr class="mt-6 mb-12">
        <p class="text-lg" v-if="error?.statusCode === 404">
          Page not found! If you are having trouble finding what you are looking for, please contact us using the
          details below.
        </p>
        <p class="text-lg" v-else>
          We're sorry, but something went wrong. We've been notified about this issue and we'll take a look at it
          shortly.
        </p>
        <UButton size="xl" class="self-start mt-6" @click="handleError">
          Go Home
        </UButton>
      </div>
      <SectionContactForm :buttons="[]" description-additional="" id="contact" subtitle="" :index="0"
        title="Get In Touch" :description="contactDescription" />

    </div>

  </div>
</template>
